import { MuiF } from '../../../../../../../Mui/F/Function/module/MuiF.js';

export const handleBottomDoneButtonClick = () => () => MuiF.closeFrame();
